module.exports = __webpack_public_path__ + "img/FinancialSpreads-logo.54db4296.png";